import Select from '../select';
import CountrySelect from './country-select';

/* istanbul ignore next */
CountrySelect.install = function install(Vue) {
  Vue.component(CountrySelect.name, CountrySelect);
  Vue.use(Select);
};

export default CountrySelect;
